<template>
    <div class="option_data_wrap">
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive">
             <!-- 右侧期权数据 -->
            <div class="option_data_content stock_detail" slot="stock_detail">
                <!-- 交易所名称以及相关信息 -->
                <div class="flex-center exchange_name">
                    <div>{{optionExchange.exchangeName}}</div>
                    <div class="ml10">
                        <el-tooltip  placement="right-start" effect="light">
                            <div slot="content" class="notice_text">{{optionExchange.exchangeInfo}}</div>
                            <i class="el-icon-question mouse-hover"></i>
                        </el-tooltip>
                    </div>
                </div>
                <!-- 金融期权 -->
                <div class="filter_wrap" v-if="activeIndex == 1">
                    <!-- 上海证券交易所 -->
                    <div v-if="optionExchange.exchangeName == '上海证券交易所'">
                        <!-- 过滤数据 -->
                        <div class="filter_button flex-center">
                            <div @click='labelSwitching(item)' v-for='item in shangHaiData.shangHaiFilterArr'
                                 :key='item.id' :class="optionExchange.filterIndex == item.id ? 'active_button' : ''">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="quotation_info">{{optionExchange.currentItem.title}}：<span>{{optionExchange.currentItem.description}}</span></div>
                        <div class="data_card">
                            <!-- 行情数据 -->
                            <div v-if="optionExchange.currentItem.title == '行情数据'">
                                <div class="top_tips">获取合约代码</div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择期权类型：</div>
                                    <div>
                                        <el-radio-group v-model="shangHaiData.type">
                                            <el-radio v-for="(item,index) in shangHaiData.typeArr" :key="index" :label="item"></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择合约到期日：</div>
                                    <el-date-picker
                                      v-model="selectDate"
                                      align="right"
                                      type="date"
                                      placeholder="选择日期"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                                <div>
                                    <el-button @click="getContractCode"  type="primary">获取合约代码</el-button>
                                </div>
                            </div>
                            <!-- 风险指标 -->
                            <div v-if="optionExchange.currentItem.title == '风险指标'">
                                <div class="top_tips">获取合约代码</div>
                                <div class='flex-center filter_item'>
                                    <div class='filter_title'>选择合约到期日：</div>
                                    <el-date-picker
                                        v-model='selectDate'
                                        align='right'
                                        type='date'
                                        placeholder='选择日期'
                                        value-format='yyyy-MM-dd'
                                        :picker-options='pickerOptions'>
                                    </el-date-picker>
                                </div>
                                <div>
                                    <el-button @click='getContractCode' type='primary'>获取合约代码</el-button>
                                    <!--                                    <el-button @click='queryTheData' type='primary'>查看数据</el-button>-->
                                </div>
                            </div>
                            <!-- 标的物实时数据 -->
                            <div v-if="optionExchange.currentItem.title == '标的物实时数据'">
                                <div class='top_tips'>选择金融期权合约名称</div>
                                <div class='filter_item'>
                                    <el-radio-group v-model='shangHaiData.type'>
                                        <el-radio v-for='(item,index) in shangHaiData.typeArr' :key='index'
                                                  :label='item'></el-radio>
                                    </el-radio-group>
                                </div>
                                <div>
                                    <el-button @click='getContractCode' type='primary'>获取合约代码</el-button>
                                    <!--                                    <el-button @click='queryTheData' type='primary'>查看数据</el-button>-->
                                </div>
                            </div>
                            <!-- 合约分时数据 -->
                            <div v-if="optionExchange.currentItem.title == '合约分时数据'">
                                <div class="top_tips">选择合约代码</div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择期权类型：</div>
                                    <div>
                                        <el-radio-group v-model="shangHaiData.contractType">
                                            <el-radio v-for="(item,index) in shangHaiData.contractTypeArr" :key="index" :label="item"></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择金融期权合约类型：</div>
                                    <div>
                                        <el-radio-group v-model="shangHaiData.type">
                                            <el-radio v-for="(item,index) in shangHaiData.typeArr" :key="index" :label="item"></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择合约到期日：</div>
                                    <el-date-picker
                                      v-model="selectDate"
                                      align="right"
                                      type="date"
                                      placeholder="选择日期"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                                <div>
                                    <el-button @click="getContractCode" type="primary">获取合约代码</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 深圳证券交易所 -->
                    <div v-if="optionExchange.exchangeName == '深圳证券交易所'">
                        <div class="quotation_info">行情数据：<span>返回当前交易日指定合约的期权行情数据</span></div>
                        <div class="data_card">
                            <div class="top_tips">获取合约代码</div>
                            <div class="flex-center filter_item">
                                <div class="filter_title">选择合约到期日：</div>
                                <el-date-picker
                                  v-model="selectDate"
                                  align="right"
                                  type="date"
                                  placeholder="选择日期"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>
                            <div>
                                <el-button @click="getContractCode" type="primary">获取合约代码</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 中国金融期货交易所 -->
                    <div v-if="optionExchange.exchangeName == '中国金融期货交易所'">
                        <!-- 过滤数据 -->
                        <div class="filter_button flex-center">
                            <div @click="optionExchange.filterIndex = item.id,optionExchange.currentItem = item" v-for="item in chinaData.chinaFilterArr" :key="item.id" :class="optionExchange.filterIndex == item.id ? 'active_button' : ''">{{item.title}}</div>
                        </div>
                        <div class="quotation_info">行情数据：<span>{{optionExchange.currentItem.description}}</span></div>
                        <div class="data_card">
                            <!-- 行情数据 -->
                            <div v-if="optionExchange.currentItem.title == '行情数据'">
                                <div class="top_tips">获取合约代码</div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择金融期权合约名称：</div>
                                    <div>
                                        <el-radio-group v-model="chinaData.type">
                                            <el-radio v-for='(item,index) in  chinaData.contractArr' :key='index'
                                                      :label='item'></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择合约到期日：</div>
                                    <el-date-picker
                                      v-model="selectDate"
                                      align="right"
                                      type="date"
                                      placeholder="选择日期"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                                <div>
                                    <el-button @click="getContractCode" type="primary">获取合约代码</el-button>
                                </div>
                            </div>
                            <!-- 实时数据 -->
                            <div v-if="optionExchange.currentItem.title == '实时数据'">
                                <div class="top_tips">选择金融期权合约名称</div>
                                <div class="flex-center filter_item">
                                    <div class="filter_title">选择金融期权合约名称：</div>
                                    <div>
                                        <el-radio-group v-model="chinaData.type">
                                            <el-radio v-for='(item,index) in  chinaData.contractArr' :key='index'
                                                      :label='item'></el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div>
                                    <el-button type='primary' @click='getContractCode'>获取合约代码</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='main_mid' v-if='!!multiChoiceList.length'>
                        <!-- 合约交易代码列表，行情数据与合约分时数据可进行查看 -->
                        <div class='data_card'>
                            <div class='top_tips'>合约代码列表
                                <el-checkbox class='ml10' v-model='checkAll' @change='checkAllContract'>全选
                                </el-checkbox>
                            </div>
                            <div>
                                <el-checkbox-group v-model='checkList'>
                                    <el-checkbox :key='index' v-for='(item,index) in multiChoiceList'
                                                 :label='item'></el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class='but_btn' style='cursor: pointer'>
                            <div class='donload_btn' @click='queryTheData'>查询数据</div>
                            <div></div>
                        </div>
                    </div>
                    <!-- 数据预览-->
                    <DataPreview
                        ref='dataPreview'
                        v-if='whetherToShowAPreview'
                        :down-load-data='downloadData'
                        api-url='/ms_resource/option/preview'
                        :queryParameters='queryParameters'
                    ></DataPreview>
                </div>

                <!-- 商品期权 -->
                <div class="filter_wrap" v-if="activeIndex == 2">
                    <div class="quotation_info">行情数据：<span>返回当前交易日指定合约的期权行情数据2</span></div>
                    <div class="data_card">
                        <div class="top_tips">选择金融期权合约名称 <el-checkbox class="ml10"  v-model="checkAll" @change="checkAllContract">全选</el-checkbox></div>
                        <div class="flex-center filter_item">
                            <el-checkbox-group v-model="checkList">
                              <el-checkbox :key="index" v-for="(item,index) in multiChoiceList" :label="index">{{'复选框' + index}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="top_tips">选择交易日期</div>
                        <div class="flex-center filter_item">
                            <div class="filter_title">选择合约到期日：</div>
                            <el-date-picker
                              v-model="stockData.selectDate"
                              align="right"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"
                              :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                        <div class="top_tips">选择要下载的数据</div>
                        <div class="flex-center filter_item">
                            <div>
                                <el-radio-group  v-model="stockData.type">
                                    <el-radio :label="0">全部</el-radio>
                                    <el-radio :label="1">上海期货交易所期权合约行情</el-radio>
                                    <el-radio :label="2">隐含波动率参考值</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- 商品期权下载数据 -->
                    <div class="download-button">
                        <el-button type="primary">数据下载</el-button>
                    </div>
                </div>

            </div>
        </StockData>
    </div>
</template>
<script>
import { contractCode, optionMenu, optionSubMenu } from '../../utils/api';

export default {
    data() {
        return {
            stokeType: '期权数据',
            menuList: [],
            activeIndex: 1,
            activeItemIndex: '',
            checkAll: false,
            checkList: [],
            selectDate: '',
            multiChoiceList: [],
                pickerOptions:{
                    disabledDate(data){
                        return data && data.valueOf() >= new Date()
                    }
                },
                shangHaiData:{
                    shangHaiFilterArr:[],
                    type:'华夏上证50ETF期权',
                    typeArr:[],
                    contractTypeArr:[],
                    contractType:'看涨期权',
                },
                chinaData:{
                    chinaFilterArr:[],
                    contractArr:[],
                    type:'沪深300股指期权'
                },
                stockData:{
                    checkList: [],
                    multiChoiceList: (new Array(20).fill('')).map((item, index) => index),
                    selectDate: '',
                    type: 0
                },
            optionExchange: {
                filterIndex: '',
                exchangeName: '上海证券交易所',
                currentItem: '',
                exchangeInfo: '上海证券交易所（以下简称上交所)）成立于1990年11月26日，同年12月19日开业，受中国证监会监督和管理，是为证券集中交易提供场所和设施、组织和监督证券交易、实行自律管理的会员制法人。经过30年的快速成长，上交所已发展成为拥有股票、债券、基金、衍生品4大类证券交易品种、市场结构较为完整的证券交易所。'
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
        },
        created(){
            this.getMenuList()
            // this.menuList = JSON.parse('[{"title":"金融期权","subMenuList":[{"id":4,"title":"上海证券交易所"},{"id":5,"title":"深圳证券交易所"},{"id":6,"title":"中国金融期货交易所"}]},{"title":"商品期权","subMenuList":[{"id":9,"title":"上海期货交易所"},{"id":10,"title":"大连商品交易所"},{"id":11,"title":"郑州商品交易所"}]}]')
        },
        methods: {
            queryTheData() {
                // if(this.checkList.length===0) return this.$message.warning('请选择合约代码')
                this.whetherToShowAPreview = true;
                // if(!this.selectDate) return this.$message.warning('请选择日期')
                this.queryParameters = {
                    date: this.selectDate,
                    codes: this.checkList.join(','),
                    financeOptionName: this.optionExchange.exchangeName === '上海证券交易所' ? this.shangHaiData.type : this.chinaData.type,
                    symbol: this.shangHaiData.contractType,
                    id: this.optionExchange.filterIndex
                };
                setTimeout(() => {
                    this.$refs.dataPreview.queryTheData();
                });
            },
            // 下载数据
            downloadData() {
                let params = {
                    date: this.selectDate,
                    codes: this.checkList,
                    financeOptionName: this.optionExchange.exchangeName == '上海证券交易所' ? this.shangHaiData.type : this.chinaData.type,
                    symbol: this.shangHaiData.contractType,
                    id: this.optionExchange.filterIndex
                };
                let url = this.$core.setObjToUrlParams(this.$config.BASE_URL + '/option/download', params);
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$core.downloadFileData('GET', url).then(res => {
                    loading.close();
                }).catch(err => {
                    loading.close();
                });
            },
            //标签切换
            labelSwitching(item) {
                this.optionExchange.filterIndex = item.id;
                this.optionExchange.currentItem = item;
                this.selectDate = '';
                this.multiChoiceList = [];
                this.whetherToShowAPreview = false;
            },
            // 清除缓存数据
            clearCache() {
                this.checkList = [];
                this.whetherToShowAPreview = false;
                this.checkAll = false;
                this.selectDate = '';
                this.multiChoiceList = [];
            },

            // 获取合约代码
            getContractCode(){
                let params = {
                    date:this.selectDate,
                    financeOptionName:this.optionExchange.exchangeName == '上海证券交易所' ? this.shangHaiData.type : this.chinaData.type,
                    id:this.optionExchange.filterIndex,
                    symbol:this.shangHaiData.contractType,
                }
                contractCode(params).then(res => {
                    this.checkList = []
                    this.checkAll = false
                    this.multiChoiceList = res.data
                }).catch(err => {})
                // this.multiChoiceList = res
            },

            // 获取期权数据目录
            getMenuList(){
                optionMenu().then(res => {
                    this.menuList = res.data
                    this.activeIndex = res.data[0].id
                    this.activeItemIndex = res.data[0].subMenuList[0].id
                    this.optionExchange.exchangeName = res.data[0].subMenuList[0].title
                    this.optionExchange.exchangeInfo = res.data[0].subMenuList[0].description
                    optionSubMenu({id:res.data[0].subMenuList[0].id}).then(res => {
                        this.shangHaiData.shangHaiFilterArr = res.data;
                        this.optionExchange.filterIndex = res.data[0].id;
                        this.optionExchange.currentItem = res.data[0];
                        this.shangHaiData.typeArr = JSON.parse(res.data[0].contract.pageCondition[0].content);
                        this.shangHaiData.contractTypeArr = JSON.parse(res.data[3].contract.pageCondition[1].content);

                    }).catch(err => {})
                }).catch(err => {})
            },

            // 商品期权选择所有合约
            checkAllContract(val){
                this.checkList = val ? this.multiChoiceList : [];
            },

            // 获取期权数据
            getOptioData(){

            },

            // el-submenu改变时获取index
            changeActive(index,item){
                this.activeIndex = item.id
            },

            // el-menu-item改变时操作
            changeItemActive(index,item){
                this.optionExchange.exchangeName = item.title
                this.optionExchange.exchangeInfo = item.description
                this.activeItemIndex = item.id
                optionSubMenu({id:item.id}).then(res => {
                    this.clearCache()
                    this.optionExchange.filterIndex = res.data[0].id
                    this.optionExchange.currentItem = res.data[0]
                    if(item.title == '上海证券交易所'){
                        this.shangHaiData.shangHaiFilterArr = res.data;
                        this.shangHaiData.typeArr = JSON.parse(res.data[0].contract.pageCondition[0].content);
                        this.shangHaiData.contractTypeArr = JSON.parse(res.data[3].contract.pageCondition[1].content);
                    }
                    if(item.title == '深圳证券交易所'){}
                    if(item.title == '中国金融期货交易所'){
                        this.chinaData.chinaFilterArr = res.data
                        this.chinaData.contractArr = JSON.parse(res.data[0].contract.pageCondition[1].content)
                    }
                    if(item.title == '上海期货交易所'){

                    }
                    if(item.title == '大连商品交易所'){}
                    if(item.title == '郑州商品交易所'){}

                }).catch(err => {})
            }

        },
    }
</script>
<style lang='scss' scoped>
.top_tips{
    padding-left: 20px;
    font-size: 20px;
    position: relative;
    left: -30px;
}
.download-button{
    margin: 20px auto 0px 90px ;
}
.data_card{
    box-sizing: border-box;
    padding: 40px 120px;
    background: white;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 10px 10px 0px 0px;
    .filter_item{
        margin-bottom: 30px;
        .filter_title{
        color: #666666;
        }
    }
    /deep/.el-checkbox{
        width: 150px;
        margin-bottom: 15px;
    }
    /deep/.el-radio__label{
        font-size: 18px;
    }
}
.quotation_info{
    font-size: 18px;
    font-weight: bold;
    color: #271B63;
    margin: 15px 0px;
    span{
        font-weight: 100;
    }
}
.filter_wrap{
    .filter_button{
        margin-top: 30px;
        >div{
            padding: 10px 40px;
            color: #666666;
            background: white;
            margin-right: 15px;
            border-radius: 4px;
            font-size: 18px;
            &:hover{
                @extend .active_button;
                cursor: pointer;
                opacity: 0.8;
            }
        }
        .active_button{
            color: white;
            background: #002D72;
        }
    }

}
.exchange_name{
    font-weight: bold;
    font-size: 24px;
    color: #271B63;
    i{
        font-size: 20px;
    }
}
.notice_text {
    max-width: 800px;
}
.option_data_content{
    width: 90%;
}
</style>
